"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnrollmentSource;
(function (EnrollmentSource) {
    EnrollmentSource[EnrollmentSource["UNKNOWN"] = 0] = "UNKNOWN";
    EnrollmentSource[EnrollmentSource["ORDER"] = 1] = "ORDER";
    EnrollmentSource[EnrollmentSource["ADMIN"] = 2] = "ADMIN";
    EnrollmentSource[EnrollmentSource["UPGRADE"] = 3] = "UPGRADE";
})(EnrollmentSource = exports.EnrollmentSource || (exports.EnrollmentSource = {}));
//# sourceMappingURL=enrollment.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/enrollment.js
// module id = 1000
// module chunks = 0